/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AppServices_Sandbox_TenantSwitchableResponseDto } from '../models/Wealthlane_AppServices_Sandbox_TenantSwitchableResponseDto';
import type { Wealthlane_Shared_Hosting_Dtos_SwitchedApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_SwitchedApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InstanceSwitchService {

    /**
     * @param companyId
     * @returns Wealthlane_AppServices_Sandbox_TenantSwitchableResponseDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiInstanceSwitchable(
        companyId?: string,
    ): CancelablePromise<Array<Wealthlane_AppServices_Sandbox_TenantSwitchableResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/instance/switchable',
            query: {
                'companyId': companyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyId
     * @param roleId
     * @returns Wealthlane_AppServices_Sandbox_TenantSwitchableResponseDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiInstanceSwitchableByRole(
        companyId?: string,
        roleId?: string,
    ): CancelablePromise<Array<Wealthlane_AppServices_Sandbox_TenantSwitchableResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/instance/switchable-by-role',
            query: {
                'companyId': companyId,
                'roleId': roleId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AppServices_Sandbox_TenantSwitchableResponseDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiInstanceSandboxOptions(): CancelablePromise<Array<Wealthlane_AppServices_Sandbox_TenantSwitchableResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/instance/sandbox/options',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param tenantId
     * @param switchRoleId
     * @returns Wealthlane_Shared_Hosting_Dtos_SwitchedApiResponse OK
     * @throws ApiError
     */
    public static getApiIdentityApiInstanceSwitch(
        tenantId: string,
        switchRoleId?: string,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_SwitchedApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/instance/switch/{tenantId}',
            path: {
                'tenantId': tenantId,
            },
            query: {
                'switchRoleId': switchRoleId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
